import React from "react";
import moment from "moment";
import {
  AlertContainer,
  AlertStoryIcon,
  AlertTextContainer,
  AlertText,
  AlertTitle,
} from "../../styles/CommonAlertElements";

export default function EpisodeAlert({ alert, ...props }) {
  return (
    <AlertContainer {...props}>
      <AlertStoryIcon>
        <img src={alert.alertImage} />
      </AlertStoryIcon>
      <AlertTextContainer>
        <AlertTitle>
          {`Episode #${alert.episodeNumber} of ${alert.storyworldName} is out now!`}
          <AlertText>{` • ${moment(alert.createdAt.toDate()).fromNow(true)}`}</AlertText>
        </AlertTitle>
      </AlertTextContainer>
    </AlertContainer>
  );
}
